// extracted by mini-css-extract-plugin
export default {"popupContainer":"nav-file-dropdown-module__popupContainer--ApmG8","skeletonContainer":"nav-file-dropdown-module__skeletonContainer--FaFxK"};